export const routerPaths = {
  '/pack-samples/toile/:slug/:file'(params: { slug: string | number, file: string | number }) {
    return buildPath('/pack-samples/toile/:slug/:file', params)
  },
  '/auth/:provider/callback'(params: { provider: string | number }) {
    return buildPath('/auth/:provider/callback', params)
  },
  '/auth/magic-link/verify': '/auth/magic-link/verify',
  '/auth/magic-link/code': '/auth/magic-link/code',
  '/auth/google/one-tap': '/auth/google/one-tap',
  '/previews/:rowId/:n'(params: { rowId: string | number, n: string | number }) {
    return buildPath('/previews/:rowId/:n', params)
  },
  '/generations/:key'(params: { key: string | number }) {
    return buildPath('/generations/:key', params)
  },
  '/auth/magic-link': '/auth/magic-link',
  '/auth/:provider'(params: { provider: string | number }) {
    return buildPath('/auth/:provider', params)
  },
  '/indexnow.txt': '/indexnow.txt',
  '/og/:slug.png'(params: { slug_png: string | number }) {
    return buildPath('/og/:slug.png', params)
  },
  '/sitemap.xml': '/sitemap.xml',
  '/wall/suggest': '/wall/suggest',
  '/robots.txt': '/robots.txt',
  '/auth/logout': '/auth/logout',
  '/chain/:root'(params: { root: string | number }) {
    return buildPath('/chain/:root', params)
  },
  '/auth/login': '/auth/login',
  '/continue': '/continue',
  '/continue/pack': '/continue/pack',
  '/tile/:id'(params: { id: string | number }) {
    return buildPath('/tile/:id', params)
  },
  '/': '/',
  '/tools': '/tools',
  '/tools/:slug'(params: { slug: string | number }) {
    return buildPath('/tools/:slug', params)
  },
  '/:packSlug'(params: { packSlug: string | number }) {
    return buildPath('/:packSlug', params)
  },
  '/take/:key'(params: { key: string | number }) {
    return buildPath('/take/:key', params)
  },
  '/privacy': '/privacy',
  '/packs': '/packs',
  '/proof': '/proof',
  '/terms': '/terms',
  '/webhook': '/webhook',
  '/health': '/health',
  '/share': '/share',
  '/touch': '/touch',
  '/mine': '/mine',
  '/seen': '/seen',
  '/wall': '/wall',
  '/pin': '/pin'
} as const

export const unsafeRouterPaths = {
  '/pack-samples/toile/:slug/:file'(params: Record<string, unknown>) {
    return unsafeBuildPath('/pack-samples/toile/:slug/:file', params)
  },
  '/auth/:provider/callback'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/:provider/callback', params)
  },
  '/auth/magic-link/verify'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/magic-link/verify', params)
  },
  '/auth/magic-link/code'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/magic-link/code', params)
  },
  '/auth/google/one-tap'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/google/one-tap', params)
  },
  '/previews/:rowId/:n'(params: Record<string, unknown>) {
    return unsafeBuildPath('/previews/:rowId/:n', params)
  },
  '/generations/:key'(params: Record<string, unknown>) {
    return unsafeBuildPath('/generations/:key', params)
  },
  '/auth/magic-link'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/magic-link', params)
  },
  '/auth/:provider'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/:provider', params)
  },
  '/indexnow.txt'(params: Record<string, unknown>) {
    return unsafeBuildPath('/indexnow.txt', params)
  },
  '/og/:slug.png'(params: Record<string, unknown>) {
    return unsafeBuildPath('/og/:slug.png', params)
  },
  '/sitemap.xml'(params: Record<string, unknown>) {
    return unsafeBuildPath('/sitemap.xml', params)
  },
  '/wall/suggest'(params: Record<string, unknown>) {
    return unsafeBuildPath('/wall/suggest', params)
  },
  '/robots.txt'(params: Record<string, unknown>) {
    return unsafeBuildPath('/robots.txt', params)
  },
  '/auth/logout'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/logout', params)
  },
  '/chain/:root'(params: Record<string, unknown>) {
    return unsafeBuildPath('/chain/:root', params)
  },
  '/auth/login'(params: Record<string, unknown>) {
    return unsafeBuildPath('/auth/login', params)
  },
  '/continue'(params: Record<string, unknown>) {
    return unsafeBuildPath('/continue', params)
  },
  '/continue/pack'(params: Record<string, unknown>) {
    return unsafeBuildPath('/continue/pack', params)
  },
  '/tile/:id'(params: Record<string, unknown>) {
    return unsafeBuildPath('/tile/:id', params)
  },
  '/'(params: Record<string, unknown>) {
    return unsafeBuildPath('/', params)
  },
  '/tools'(params: Record<string, unknown>) {
    return unsafeBuildPath('/tools', params)
  },
  '/tools/:slug'(params: Record<string, unknown>) {
    return unsafeBuildPath('/tools/:slug', params)
  },
  '/:packSlug'(params: Record<string, unknown>) {
    return unsafeBuildPath('/:packSlug', params)
  },
  '/take/:key'(params: Record<string, unknown>) {
    return unsafeBuildPath('/take/:key', params)
  },
  '/privacy'(params: Record<string, unknown>) {
    return unsafeBuildPath('/privacy', params)
  },
  '/packs'(params: Record<string, unknown>) {
    return unsafeBuildPath('/packs', params)
  },
  '/proof'(params: Record<string, unknown>) {
    return unsafeBuildPath('/proof', params)
  },
  '/terms'(params: Record<string, unknown>) {
    return unsafeBuildPath('/terms', params)
  },
  '/webhook'(params: Record<string, unknown>) {
    return unsafeBuildPath('/webhook', params)
  },
  '/health'(params: Record<string, unknown>) {
    return unsafeBuildPath('/health', params)
  },
  '/share'(params: Record<string, unknown>) {
    return unsafeBuildPath('/share', params)
  },
  '/touch'(params: Record<string, unknown>) {
    return unsafeBuildPath('/touch', params)
  },
  '/mine'(params: Record<string, unknown>) {
    return unsafeBuildPath('/mine', params)
  },
  '/seen'(params: Record<string, unknown>) {
    return unsafeBuildPath('/seen', params)
  },
  '/wall'(params: Record<string, unknown>) {
    return unsafeBuildPath('/wall', params)
  },
  '/pin'(params: Record<string, unknown>) {
    return unsafeBuildPath('/pin', params)
  }
} as const

export type RouterPath = keyof typeof routerPaths

export type RouterParams = {
  '/pack-samples/toile/:slug/:file': { slug: string, file: string },
  '/auth/:provider/callback': { provider: string },
  '/auth/magic-link/verify': {  },
  '/auth/magic-link/code': {  },
  '/auth/google/one-tap': {  },
  '/previews/:rowId/:n': { rowId: string, n: string },
  '/generations/:key': { key: string },
  '/auth/magic-link': {  },
  '/auth/:provider': { provider: string },
  '/indexnow.txt': {  },
  '/og/:slug.png': { slug_png: string },
  '/sitemap.xml': {  },
  '/wall/suggest': {  },
  '/robots.txt': {  },
  '/auth/logout': {  },
  '/chain/:root': { root: string },
  '/auth/login': {  },
  '/continue': {  },
  '/continue/pack': {  },
  '/tile/:id': { id: string },
  '/': {  },
  '/tools': {  },
  '/tools/:slug': { slug: string },
  '/:packSlug': { packSlug: string },
  '/take/:key': { key: string },
  '/privacy': {  },
  '/packs': {  },
  '/proof': {  },
  '/terms': {  },
  '/webhook': {  },
  '/health': {  },
  '/share': {  },
  '/touch': {  },
  '/mine': {  },
  '/seen': {  },
  '/wall': {  },
  '/pin': {  }
}

type InputParams = {
  '/pack-samples/toile/:slug/:file': { slug: string | number, file: string | number },
  '/auth/:provider/callback': { provider: string | number },
  '/auth/magic-link/verify': {  },
  '/auth/magic-link/code': {  },
  '/auth/google/one-tap': {  },
  '/previews/:rowId/:n': { rowId: string | number, n: string | number },
  '/generations/:key': { key: string | number },
  '/auth/magic-link': {  },
  '/auth/:provider': { provider: string | number },
  '/indexnow.txt': {  },
  '/og/:slug.png': { slug_png: string | number },
  '/sitemap.xml': {  },
  '/wall/suggest': {  },
  '/robots.txt': {  },
  '/auth/logout': {  },
  '/chain/:root': { root: string | number },
  '/auth/login': {  },
  '/continue': {  },
  '/continue/pack': {  },
  '/tile/:id': { id: string | number },
  '/': {  },
  '/tools': {  },
  '/tools/:slug': { slug: string | number },
  '/:packSlug': { packSlug: string | number },
  '/take/:key': { key: string | number },
  '/privacy': {  },
  '/packs': {  },
  '/proof': {  },
  '/terms': {  },
  '/webhook': {  },
  '/health': {  },
  '/share': {  },
  '/touch': {  },
  '/mine': {  },
  '/seen': {  },
  '/wall': {  },
  '/pin': {  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function buildPath<TRouterPath extends RouterPath>(route: TRouterPath, params: InputParams[TRouterPath]) {
  return route
    .replace(/'/g, '')
    .split('/')
    .map((part) =>
      part.startsWith(':') ? params[part.replace(':', '').replace('?', '') as keyof InputParams[TRouterPath]] : part,
    )
    .filter((part) => part !== undefined)
    .join('/')
}

function unsafeBuildPath<TRouterPath extends RouterPath>(
  route: TRouterPath,
  params: Record<string, unknown>,
) {
  return route
    .replace(/'/g, '')
    .split('/')
    .map((part) => (part.startsWith(':') ? params[part.replace(':', '').replace('?', '')] : part))
    .filter((part) => part !== undefined)
    .join('/')
}
